document.querySelectorAll('.IndexMainFilters').forEach((el) => {
    const inputs = el.querySelectorAll('*[data-subtype-list] input');
    const containers = el.querySelectorAll('*[data-subtype-show]');

    inputs.forEach((input) => {
        input.addEventListener('change', () => {
            const value = input.value;
            containers.forEach((container) => {
                const ids = container.dataset.subtypeShow.split(',');
                const isHide = !ids.includes(value);
                if(isHide) {
                    container.setAttribute('data-subtype-hidden', '1');
                }
                else {
                    container.removeAttribute('data-subtype-hidden');
                }
            });
        });
    })
});
